import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks, PasswordKey } from "@simulanisindia/ui";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import moment from "moment";
import { ApplicationIcon, EditIcon, GroupIcon, UserIcon } from "../../assets/Icons";
import { InfoIcon } from "../../Icons";
import SettingTeamManagement from "../SettingTeamManagement";
import PasswordChangeModal from "../../modal/PasswordChangeModal";
import { useModalContext } from "../../modal/context/ModalProvider";
import apiClient from "../../apiClient";
import { FETCH_USER_WITH_ASSIGNED_RESOURCE_COUNT } from "../../apiClient/apiEndpoints";
import { getPlaceholderName } from "../../utils/general";
import { toolTip } from "../Tooltips/CustomTooltip";


const { SimToggleSwitch, IconButton, SimModal, SimTooltip } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ParentGroupInfo = ({ userMode, handleRefreshTab, details }) => {
  const { openModal } = useModalContext();
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData?.config?.UNO_URL;
  const params = useParams();
  const [userDetails, setUserDetails] = useState({});
  const [passwordModal, setPasswordModal] = useState(false);
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  const getUserDetails = async () => {
    const res = await apiClient.get(`${UNO_URL}${FETCH_USER_WITH_ASSIGNED_RESOURCE_COUNT}/${params.uuid}`);
    setUserDetails(res);
  };

  useEffect(() => {
    if (userMode) {
      getUserDetails();
    }
  }, [params?.uuid]);


  const groupActions = [
    {
      text: "Group",
      icon: <GroupIcon />,
      onClick: () => openModal({ modalName: "GROUP_ADD", type: "create", id: null, params, handleRefreshTab }),
    },
    {
      text: "User",
      icon: <UserIcon />,
      onClick: () => openModal({ modalName: "USER_ADD", type: "create", id: null, params, handleRefreshTab }),
    },
    {
      text: "Application",
      icon: <ApplicationIcon />,
      onClick: () => navigate(`/resource-management`),
    },
  ];

  const avatarSrc = userMode ? userDetails?.avatar : details?.avatar;
  const userName = userMode ? userDetails?.name : details?.name;

  return (
    <>
      <div className="parent-group">
        <div className="group-function-parent">
          <div className="group-info">
            <div className={`profile ${userMode ? "for-user" : ""}`}>
              <div className="bg">
                {(avatarSrc && !imageError) ? (
                  <img src={avatarSrc} referrerPolicy="no-referrer" onError={() => setImageError(true)} alt="avatar" />
                ) : (
                  <span className="initials">{getPlaceholderName(userName)}</span>
                )}
              </div>
              {/* {!userMode && <span className="pro">PRO</span>} */}
            </div>

            <p className="name">{userMode ? userDetails?.name : details.name}</p>
            {details?.identifier && <p className="groupid m-0">{details?.identifier}</p>}
            {userMode && <p className="des">{userDetails?.designation}</p>}
            {details?.type?.name && <p className="Tag"> {details?.type?.name || null} </p>}

            {userMode ? (
              <>
                <div className="id-mail">
                  <p>{userDetails?.uid}</p>
                  <p>{userDetails?.email}</p>
                </div>
                <div className="group-edit">
                  <span className="edit-btn mb-2" onClick={() => setPasswordModal(true)}>
                    Change Password <PasswordKey />
                  </span>
                </div>
              </>
            )
              :
              <div className="action-btn ">
                {groupActions.map(({ text, icon, onClick }) => (
                  <SimTooltip key={text} text={text} placement="top">
                    <div className="Icon-btn">
                      <IconButton Icon={icon} onClick={onClick} />
                    </div>
                  </SimTooltip>
                ))}
              </div>
            }

            {/* {userMode &&
              <SimTooltip text="Change_password" placement="top">
                <div onClick={() => setPasswordModal(true)} className="pass-btn">
                  <PasswordKey />
                </div>
              </SimTooltip>
            } */}
          </div>

          <div className="group-functions">
            {userMode ? (
              <>
                <div className="function-item">
                  <h6>User Settings</h6>
                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Inherited </p>
                      <div className="toggle-function">
                        <SimToggleSwitch checked={userDetails?.inherit} />
                      </div>
                    </div>
                    <p className="info-message"> Inherit all applications and resources from Parent Group</p>
                  </div>
                </div>

                <div className="function-item">
                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Applications </p>
                      <div className="text-output">
                        {userDetails?.count?.applications || 0}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={toolTip({ text: `These are total application of ${userDetails?.name}` })}
                        >
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Resources </p>
                      <div className="text-output">
                        {userDetails?.count?.resources || 0}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={toolTip({ text: `These are total resources of ${userDetails?.name}` })}
                        >
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="function-item">
                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Groups </p>
                      <div className="text-output">
                        {details.groups || 0}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={toolTip({ text: `This is a total groups inside ${details.name}` })}
                        >
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>

                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Users </p>
                      <div className="text-output">
                        {details.users || 0}
                        <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={toolTip({ text: `This is a total users inside ${details.name}` })}>
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </div>

                <SettingTeamManagement type="group" />
              </>
            )}
          </div>
        </div>

        <div className="group-edit">
          <span
            className="edit-btn"
            onClick={() =>
              openModal({
                modalName: userMode ? "USER_ADD" : "GROUP_ADD",
                type: "update",
                id: userMode ? userDetails?.uuid : details.uuid,
                params
              })
            }
          >
            Edit <EditIcon />
          </span>
          <p>
            {userMode ? "USER" : "GROUP"} SINCE:
            {moment(userMode ? userDetails?.createdAt : details.createdAt).format("LL")}
          </p>
        </div>

      </div>

      <SimModal showModal={passwordModal} onHide={() => setPasswordModal(false)} centered={true} size="md">
        <PasswordChangeModal onHide={() => setPasswordModal(false)} />
      </SimModal>

      {/* <ConfirmBox showModal={confirmModal} alertTitle="Delete" ActionButtonItem="Save" onHide={() => setConfirmModal(false)} alertMessage="Are you sure?"/>        */}
    </>
  );
};

export default ParentGroupInfo;
